<template>
    <div>
        <div class="intro-more-sources">
            <span><router-link :to="`/story/${story.slug}`" class="router-link">{{setMaxSources(story.sources)}} more sources</router-link></span>
            <global-svg type="arrow" color="#868C8C" width="11px" height="11px"></global-svg>
        </div>
        <reason :slug="slug"></reason>
    </div>
</template>

<script>
    import { Mixins } from '../mixins'
    import Reason from '../partials/Reason';

    export default {
        props: ['slug', 'story'],
        mixins: [Mixins],
        components: {
            Reason
        },
        methods: {
            setMaxSources(sources) {
                return sources;
            },
        }   
    }
</script>

<style lang="scss" scoped>
    @import '~styles/_variables';

    .intro-more-sources {
        display: flex;
        color: $base-secondary;
        font-size: 12px;
        margin-bottom: 15px;
        cursor: pointer;

        span {
            margin-right: 5px;
        }
    }

</style>